<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.siparis1.liste.baslik")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    border
                    stripe
                    :data="siparisList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="250">
                </el-table-column>
                <el-table-column
                        prop="telefon"
                        label="Telefon"
                        width="180">
                </el-table-column>
                <el-table-column
                        label="İl/İlçe"
                        width="180">
                    <template slot-scope="props">
                        {{props.row.il}}/{{props.row.ilce}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="adres"
                        label="Adres"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="100">
                    <template slot-scope="scope">
                        <el-dropdown @command="handleCommand($event,scope.row,scope.$index)" trigger="click"><span
                                class="el-dropdown-link"><i class="mdi mdi-folder-search mdi-18px"></i><i
                                class="el-icon-arrow-down el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="3" style="color: #f7ba2a; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Hazır
                                </el-dropdown-item>
                                <el-dropdown-item command="4"
                                                  style="color: #0075c3; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Kargoda
                                </el-dropdown-item>
                                <el-dropdown-item command="5" style="color: #ec205f; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">İptal
                                </el-dropdown-item>
                                <el-dropdown-item command="6" style="color: #13ce66; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">Teslim Edildi
                                </el-dropdown-item>
                                <el-dropdown-item command="7" style="color: #1A2226; margin-right: 5px"
                                                  icon="mdi mdi-sort mdi-18px">İade
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="durumChangeDialog"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" müşterisinin sipariş durumunu değiştirmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="siparisDurumChange(selection,selectionIndex,siparisList,durum), durumChangeDialog = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="durumChangeDialog = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import siparisService from '../../../WSProvider/MusteriService'

    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataKader = "";

    export default {
        name: "Siparisler",
        data() {
            return {
                filtersSorumlu: [],
                dialogVisibleUrunBaglanti: false,
                urundata: {},
                // path: urunService.path,
                // imagepath: urunService.imageUrlOrta,
                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,
                siparisList: [],
                durumChangeDialog: false,
                selection: '',
                selectIcon: '2',
                radio: '2',
                selectionIndex: '',
                durum: '',
                root: false,
                yetkiList: {
                    urunGuncelle: false,
                    urunDurumChange: false,
                },
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataKader")) {
                var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
if (userDataKader["tur"]) {
                    if (userDataKader["tur"] === '1' || userDataKader["tur"] === '2') {
                        self.root = true;
                        self.yetkiList.urunDurumChange = true;
                        self.yetkiList.urunGuncelle = true;
                    }
                }
                if (userDataKader["yetki"]) {
                    userDataKader["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-482800':
                                self.yetkiList.urunGuncelle = true;
                                self.yetkiList.urunDurumChange = true;
                                break;
                            case 'YK-462516':
                                self.yetkiList.urunDurumChange = true;
                                break;
                        }
                    });
                }

            }
            this.siparisCount();
            this.getSiparisList();
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getSiparisList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getSiparisList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getSiparisList();
            },
            siparisCount() {
                siparisService.siparisCount(this.$store.state.siparisTuru).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            handleCommand(command, row, index) {
                this.selection = row;
                this.selectionIndex = index;
                this.durum = command;
                this.durumChangeDialog = true;
            },
            routeUrun(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.urunKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getSiparisList() {
                let self = this;
                siparisService.siparisListesi(this.$store.state.siparisTuru, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.siparisList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            siparisDurumChange(selection, index, list, durum) {
                siparisService.siparisDurumGuncelle(selection.siparisKodu, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status("success", this, "Durum değişikliği başarılı..");
                        list.splice(index, 1);
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss">
    .el-table .info-row {
        background: rgba(125, 199, 225, 0.45);
    }

    .el-table .error-row {
        background: rgba(249, 0, 26, 0.08);
    }

    .el-table .success-row {
        background: rgba(3, 249, 0, 0.08);
    }

    .el-table .warning-row {
        background: rgba(245, 249, 0, 0.08);
    }
</style>
<style lang="scss" scoped>
    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: rotate(360deg);
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>